var styleDataHash = '2e77dcda';  
export const injectCss = (() => {
  var css = `.VegOQ{margin-left:0;margin-right:auto;z-index:1}.VegOQ:not(.swhHa){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.VegOQ:not(.swhHa){float:none;margin-right:auto}}}@container (width < 480px){.VegOQ:not(.swhHa){float:none;margin-right:auto}}.Wa83i{margin-left:auto;margin-right:0;z-index:1}.Wa83i:not(.swhHa){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.Wa83i:not(.swhHa){float:none;margin-left:auto}}}@container (width < 480px){.Wa83i:not(.swhHa){float:none;margin-left:auto}}._3PcS9{clear:both;display:block}._3PcS9:not(._7CpFQ){margin-left:auto;margin-right:auto;max-width:100%}._7CpFQ,.swhHa{width:100%}.WW4lX ._7CpFQ,.WW4lX .swhHa{margin:0 -8px;width:auto}.ozzgJ{width:fit-content}.l41Vz{margin-left:auto;margin-right:auto;max-width:100%}.-P4UH{width:min(350px,100%)!important}.WW4lX .-P4UH{width:50%}.dwA63{margin-left:auto;margin-right:auto}.WW4lX .dwA63{width:150px}.CUkAS{display:flex}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "alignLeft": "VegOQ",
  "textWrapNowrap": "swhHa",
  "alignRight": "Wa83i",
  "alignCenter": "_3PcS9",
  "sizeFullWidth": "_7CpFQ",
  "renderedInTable": "WW4lX",
  "sizeOriginal": "ozzgJ",
  "sizeContent": "l41Vz",
  "sizeSmall": "-P4UH",
  "sizeSmallCenter": "dwA63",
  "flex": "CUkAS"
};